module.exports = __webpack_public_path__ + "static/img/11.40b1c17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/11.png
// module id = Sn4Q
// module chunks = 0